<template>
  <v-data-table-server
    v-model:options="options"
    dense
    :headers="headers"
    :loading="dataLoading"
    :items="items"
    :items-length="totalItems"
    class="elevation-1"
    :items-per-page-options="footerProps.itemsPerPageOptions"
    @update:options="updateTable"
  >
    <template #top>
      <v-card-title>
        <v-toolbar flat>
          <v-toolbar-title>Bad ABA List</v-toolbar-title>

          <v-spacer />

          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            @input="searchTable()"
          />

          <v-spacer />

          <BadAbaDeleteModal
            v-model="dialogDelete"
            :edited-item="editedItem"
            @close-modal="closeModal('dialogDelete')"
            @item-deleted="deleteItemConfirm()"
            @click:outside="clearState()"
          />

          <BadAbaFormModal
            v-model="dialogForm"
            :action="formAction"
            :edited-item="editedItem"
            @close-modal="closeModal('dialogForm')"
            @item-saved="itemSaved()"
            @click:outside="clearState()"
          />

          <v-btn
            v-if="hasPermission('create lending-strategies::bad-aba')"
            dark
            class="mb-2 btn-bg-deep-blue"
            @click="openFormModal()"
          >
            <v-icon>mdi-plus</v-icon>
            New Bad ABA
          </v-btn>
          <disabled-for-lack-of-role-btn
            v-else
            text="New Bad ABA"
            permission="create lending-strategies::bad-aba"
            :x-small="false"
            button-class="mb-2"
          />
        </v-toolbar>
      </v-card-title>
    </template>

    <template #item.actions="{ item }">
      <v-icon
        v-if="hasPermission('edit lending-strategies::bad-aba')"
        :id="item"
        class="mr-10"
        @click="openFormModal('update', item)"
      >
        mdi-pencil-outline
      </v-icon>
      <disabled-for-lack-of-role-btn
        v-else
        text=""
        icon="mdi-pencil-outline"
        :text-button="true"
        permission="edit lending-strategies::bad-aba"
        :x-small="false"
        button-class="mr-10"
      />

      <v-icon
        v-if="hasPermission('delete lending-strategies::bad-aba')"
        class="red--text"
        @click="deleteItem(item)"
      >
        mdi-delete-outline
      </v-icon>
      <disabled-for-lack-of-role-btn
        v-else
        text=""
        icon="mdi-delete-outline"
        :text-button="true"
        permission="delete lending-strategies::bad-aba"
        :x-small="false"
        button-class="mr-10"
      />
    </template>
  </v-data-table-server>
</template>

<script>
import dataTableMixin from '@/mixins/dataTableMixin.js';

import BadAbaDeleteModal from './BadAbaDeleteModal.vue';
import BadAbaFormModal from './BadAbaFormModal.vue';
import DisabledForLackOfRoleBtn from '../../DisabledForLackOfRoleBtn.vue';

export default {
  components: {
    BadAbaDeleteModal,
    BadAbaFormModal,
    DisabledForLackOfRoleBtn,
  },
  mixins: [
    dataTableMixin,
  ],
  data: () => ({
    dataLoading: true,
    headers: [
      { title: 'ABA', value: 'aba' },
      { title: 'Bank Name', value: 'bank_name' },
      { title: 'Actions', value: 'actions', sortable: false },
    ],

    editedItem: {},
    dialogDelete: false,
    dialogForm: false,
    formAction: 'add',
    snackbar: true,
  }),
  methods: {
    deleteItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = { ...item };
      this.dialogDelete = true;
    },
    closeModal(modal) {
      this[modal] = false;
      this.clearState();
    },
    deleteItemConfirm() {
      this.items = [];
      this.updateTable();
    },
    openFormModal(action = 'add', item = null) {
      this.dialogForm = true;

      this.formAction = action;

      if (action === 'update') {
        this.editedItem = item;
      }
    },
    itemSaved() {
      this.items = [];
      this.updateTable();
    },
    updateTable() {
      this.dataLoading = true;

      return this.$axios
        .get('api/v1/bad-aba', {
          params: {
            perPage: this.options.itemsPerPage,
            page: this.options.page,
            ...this.sortParams,
            search: this.search,
          },
        })
        .then((res) => {
          setTimeout(() => {
            this.dataLoading = false;
            this.items = res.data.data;
            this.totalItems = res.data.total;
          }, 1000);
        });
    },
    clearState() {
      this.$nextTick(() => {
        this.editedItem = {};
        this.editedIndex = -1;
      });
    },
  },
};
</script>
